export const isVideoPath = (path: string): boolean => {
  const extension = path.split('.')[1];
  return extension === 'mp4' || extension === 'mov';
};

export const isV2Event = (created_at: string): boolean => {
  return new Date(created_at).getTime() >= 1682956375030;
};
